export default __webpack_public_path__ + "sidebar_bg.jpg";